module.exports = __webpack_public_path__ + "img/lock.10fbea1a.svg";